import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Grid, Typography, useEventCallback } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { useFormikContext } from 'formik';
import { StatementsFormVM } from 'front-office/view-models/statements/statements-form';
import { CertificateTypeANPRList } from 'shell/models/certificate-type';
import StatementsCheckboxes from './statements-checkboxes';

const StatementsComponent = (): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const formContext = useFormikContext<StatementsFormVM>();

  const onChange = useEventCallback((identifier: CertificateTypeANPRList) => {
    const isSelected =
      formContext.values.statements?.key.codiceDocumento === identifier.key.codiceDocumento;

    formContext.setFieldValue('statements', isSelected ? undefined : identifier);

    if (!formContext.values.certificateInternOnly && identifier.dettaglioModalitaRilascio) {
      formContext.setFieldValue(
        'modality',
        isSelected
          ? undefined
          : {
              id: identifier.dettaglioModalitaRilascio.key?.codiceModalitaRilascio,
              value: identifier.dettaglioModalitaRilascio.descrizione,
              amountTaxStamp: identifier.dettaglioModalitaRilascio.importoImpostaBollo
                ? Number.parseFloat(identifier.dettaglioModalitaRilascio.importoImpostaBollo)
                : 0,
              amountRightsSecretariat: identifier.dettaglioModalitaRilascio.importoDirittiSegreteria
                ? Number.parseFloat(identifier.dettaglioModalitaRilascio.importoDirittiSegreteria)
                : 0,
              amountRightsCivilState: identifier.dettaglioModalitaRilascio.importoDirittiStatoCivile
                ? Number.parseFloat(identifier.dettaglioModalitaRilascio.importoDirittiStatoCivile)
                : 0,
              amountFixedRights: identifier.dettaglioModalitaRilascio.importoDirittiFissi
                ? Number.parseFloat(identifier.dettaglioModalitaRilascio.importoDirittiFissi)
                : 0,
              amountExpenses: identifier.dettaglioModalitaRilascio.importoSpese
                ? Number.parseFloat(identifier.dettaglioModalitaRilascio.importoSpese)
                : 0,
              codeExemptionAnpr: identifier.dettaglioModalitaRilascio.codiceEsenzioneAnpr,
              registryType: identifier.dettaglioModalitaRilascio.tipoRegistro,
              descrizioneModalitaStampa:
                identifier.dettaglioModalitaRilascio.descrizioneModalitaStampa,
              disabled: true,
            }
      );
    }
  });

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-statements-anpr-content"
        id="panel-statements-anpr-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Dichiarazioni Sostitutive Notorietà</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <StatementsCheckboxes onChange={onChange} values={formContext.values.statements} />
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

StatementsComponent.displayName = 'Accordion statements component';

const StatementsAnpr = memo(StatementsComponent);

export default StatementsAnpr;
